module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","employersEntrance":"Employer sign in","email":"E-mail","pass":"Password","rememberMe":"Remember me","registration":"Registration","passReset":"Reset password","siteMovedToRu":"The site has been moved to the new domain Huntica.io","autoRedirectedMessage":"You have been automatically redirected because the Huntica.works site now operates in the .io domain zone"}}')
  delete Component.options._Ctor
}
